<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptitle"><a id="con"></a>CONTENTS</h1>
<p style="text-align:center; margin-top:.5pc"></p>
<p class="center"><img alt="Image" src="images/dw.jpg"/></p>
<p style="text-align:center; margin-top:.5pc"></p>
<p class="toc1"><a href="#/07_introduction#int">Introduction</a></p>
<p class="toc"><a href="#/08_chapter01#c1">1. The Purposes and Methodologies of Black Magick</a></p>
<p class="toc"><span href="#/09_chapter02#c2" title="Link target outside of Sample">2. H. P. Lovecraft: Prophet of the Aeon of the Great Old Ones</span></p>
<p class="toc"><span href="#/10_chapter03#c3" title="Link target outside of Sample">3. The Spurious Necronomicons</span></p>
<p class="toc"><span href="#/11_chapter04#c4" title="Link target outside of Sample">4. The Simon/Schlangekraft Necronomicon</span></p>
<p class="toc"><span href="#/12_chapter05#c5" title="Link target outside of Sample">5. The Great Old Ones</span></p>
<p class="toc"><span href="#/13_chapter06#c6" title="Link target outside of Sample">6. Lovecraft and the Afro-Haitian Vodou Cults</span></p>
<p class="toc"><span href="#/14_chapter07#c7" title="Link target outside of Sample">7. Lovecraft and the Wiccan Religion</span></p>
<p class="toc"><span href="#/15_chapter08#c8" title="Link target outside of Sample">8. Lovecraft and the Typhonian O.T.O.</span></p>
<p class="toc"><span href="#/16_chapter09#c9" title="Link target outside of Sample">9. Lovecraft and the Church of Satan</span></p>
<p class="toc"><span href="#/17_chapter10#c10" title="Link target outside of Sample">10. Lovecraft and the Chaos Magick Pacts</span></p>
<p class="toc"><span href="#/18_chapter11#c11" title="Link target outside of Sample">11. Conclusion</span></p>
<p class="toc1"><span href="#/19_notes#note" title="Link target outside of Sample">Notes</span></p>
<p class="toc1"><span href="#/20_index#ind" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_contents.vue?02b8ee2b